// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1861) return "static/chunks/1861-a88e671e2f9b1d8c.js";
	if (chunkId === 7754) return "static/chunks/7754-eb5a75ba87e9dc01.js";
	if (chunkId === 6427) return "static/chunks/6427-bb4788192b2263d7.js";
	if (chunkId === 9754) return "static/chunks/9754-3ac2b2571c0368bc.js";
	if (chunkId === 9384) return "static/chunks/9384-6706eb901677b552.js";
	if (chunkId === 3065) return "static/chunks/3065-7a1ed6085bfd3fae.js";
	if (chunkId === 4110) return "static/chunks/4110-dd911ba926138f4a.js";
	if (chunkId === 8411) return "static/chunks/8411-6f0a9a8ddc9748d1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1853":"f05bd95423181044","4980":"2825104807b6d789","5576":"b7137f73b565cad9","8373":"08b17b9d996b2195","8406":"810d761d571ab7fd","8968":"1dbd2954c653fa09","9616":"cdd8746d552f431b","9760":"be8a04c7c4829c47"}[chunkId] + ".js";
};